





















import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import ActivityMixin from '@/assets/ts/mixins/ActivityMixin.ts';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin.ts';
import { EventBus } from '@/plugins/event-bus';
import { Papybase, PapybaseConfig, ForwardInfo } from '@luxtag/papybase';

const ForwardPageProps = Vue.extend({
    props: {
        base: String
    }
});

@Component
export default class ForwardPage extends ForwardPageProps {

    public mounted() {
        const { forward } = this.$route.params;
        if (forward === undefined) {
            this.$router.push({name: 'page-not-found'});
            return;
        }
        this.getForwardInfo(forward);
    }

    public async getForwardInfo(forward: string) {
        let forwardInfo: ForwardInfo;
        try {
            if (this.base === 'v') {
            forwardInfo = await this.papybaseX4.forward().getForwardURL(forward);
            } else {
            forwardInfo = await this.papybaseX1.forward().getForwardURL(forward);
            }
            if (forwardInfo.forwarded_url.length > 0) {
                window.open(forwardInfo.original_url, '_self');
            } else {
                this.$router.push({name: 'page-not-found'});
            }
        } catch (e) {
            this.$router.push({name: 'page-not-found'});
        }
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            // access to component instance via `vm`
            EventBus.$emit('change-active-tab', 0);
        });
    }

    get papybaseX1(): Papybase {
        const papybaseConfig: PapybaseConfig = {
            baseURL: 'https://api.event.luxtag.io',
            timeout: 8000,
        };

        return Papybase.initializeApp(papybaseConfig);
    }

    get papybaseX4(): Papybase {
        const papybaseConfig: PapybaseConfig = {
            baseURL: 'https://trasee.brandtag.io',
            timeout: 8000,
        };

        return Papybase.initializeApp(papybaseConfig);
    }

}
